import { PublicPagesTranslate } from './publicPagesTranslate.model';

const publicPagesTranslateEN: PublicPagesTranslate = {
  sign: {
    loading: 'Loading contract…',
    legalNotice:
      'Electronic signature valid under Brazilian MP 2.200-2/2001. The acceptance is recorded with date, time and IP address.',
    notFound: {
      title: 'Invalid or expired link',
      message:
        'We could not find this contract. The link may have expired or be incorrect.',
    },
    expired: {
      title: 'Link expired',
      message:
        'The deadline to sign this contract has passed. Please contact the studio to receive a new link.',
    },
    canceled: {
      title: 'Request canceled',
      message: 'This signature request was canceled by the studio.',
    },
    accepted: {
      title: 'Contract signed',
      message: 'This contract was electronically signed on {{date}}.',
    },
    ready: {
      title: 'Electronic contract signature',
      description: 'Review the details below and sign electronically.',
      templateLabel: 'Contract',
      leadLabel: 'Client',
      viewPdf: 'View contract (PDF)',
    },
    form: {
      signerName: 'Full name',
      signerDocument: 'Document (optional)',
      agree: 'I have read and agree to the contract terms',
      submit: 'Sign electronically',
      conflictError:
        'Could not register the signature. The contract may have changed or already been signed. Reload the page and try again.',
      validation: {
        signerNameRequired: 'Enter your full name',
        signerNameMaxLength: 'The name must be at most 256 characters',
        signerDocumentInvalid: 'Enter a valid document',
        agreedRequired: 'You must agree to the terms to sign',
      },
    },
  },
  leadForm: {
    loading: 'Loading form…',
    title: 'Get in touch',
    description: 'Fill out the form and {{studioName}} will get back to you.',
    submit: 'Send',
    submitError: 'Could not send. Please try again.',
    notFound: {
      title: 'Form unavailable',
      message: 'This form is no longer available or the link is invalid.',
    },
    success: {
      title: 'Received!',
      message: 'Thanks for reaching out. {{studioName}} will get back soon.',
    },
    fields: {
      website: 'Website',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      instagram: 'Instagram',
      source: 'How did you hear about us?',
      notes: 'Message',
    },
    validation: {
      nameRequired: 'Enter your name',
      nameMaxLength: 'The name must be at most 256 characters',
      emailRequired: 'Enter your email',
      emailInvalid: 'Enter a valid email',
      phoneMaxLength: 'The phone must be at most 32 characters',
      instagramMaxLength: 'Instagram must be at most 128 characters',
      notesMaxLength: 'The message must be at most 2000 characters',
    },
  },
};

export default publicPagesTranslateEN;
